var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpressService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a61c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#530e0a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-975 -501)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 90,
    height: 90,
    rx: 22,
    transform: "translate(975 501)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(986.657 511.314)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47,56h2.1v2.1H47Z",
    transform: "translate(2.082 2.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43,56h2.1v2.1H43Z",
    transform: "translate(1.886 2.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.245,62.708V42.781h3.146a1.049,1.049,0,0,0,.944-1.518l-4.2-8.39a1.049,1.049,0,0,0-.944-.58H35.042a8.378,8.378,0,0,0-16.229,0H12.244a1.049,1.049,0,0,0-.939.58l-4.2,8.39a1.049,1.049,0,0,0,.939,1.518H11.2V62.708a1.049,1.049,0,0,0,1.049,1.049H54.2A1.049,1.049,0,0,0,55.245,62.708ZM26.927,28.1A6.3,6.3,0,0,1,33.22,34.39a6.188,6.188,0,0,1-.365,2.1H25.264l5.551-5.551-1.483-1.483L22.3,36.488H21a6.188,6.188,0,0,1-.365-2.1A6.3,6.3,0,0,1,26.927,28.1ZM9.746,40.683l3.146-6.293h5.645a8.246,8.246,0,0,0,.28,2.1H16.439v2.1H50v-2.1H35.038a8.246,8.246,0,0,0,.28-2.1h18.23l3.146,6.293Zm43.4,20.976H13.293V42.781H53.147Z",
    transform: "translate(0.13 1.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.764,26.089A6.982,6.982,0,0,0,25.7,14.17L16.262,4.731A6.982,6.982,0,1,0,6.388,14.6l9.439,9.439a6.933,6.933,0,0,0,4.937,2.045ZM7.871,13.122a4.884,4.884,0,1,1,6.907-6.907l3.454,3.454-6.907,6.907Zm11.844-1.971,4.5,4.5a4.884,4.884,0,0,1-6.907,6.907l-4.5-4.5Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.529,8.358l-.789-1.943a3.985,3.985,0,0,0-2.4,2.72C8.1,10.5,8.8,11.942,10.429,13.41l1.405-1.557c-1.022-.922-1.529-1.755-1.427-2.347C10.527,8.8,11.52,8.362,11.529,8.358Z",
    transform: "translate(0.193 0.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.47,14.79a6.24,6.24,0,0,0-10.653-4.412l-9.439,9.439A6.24,6.24,0,1,0,51.2,28.642L60.642,19.2A6.2,6.2,0,0,0,62.47,14.79ZM49.72,27.159A4.143,4.143,0,1,1,43.861,21.3l3.978-3.978L53.7,23.181Zm9.439-9.439L55.181,21.7l-5.859-5.859L53.3,11.861a4.143,4.143,0,1,1,5.859,5.859Z",
    transform: "translate(1.767 0.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.683,13.342a7.342,7.342,0,1,0-7.342,7.342,7.342,7.342,0,0,0,7.342-7.342ZM36.342,8.1a5.236,5.236,0,0,1,4.37,8.131L33.454,8.971A5.208,5.208,0,0,1,36.342,8.1ZM31.1,13.342a5.211,5.211,0,0,1,.873-2.886l7.258,7.257a5.236,5.236,0,0,1-8.131-4.37Z",
    transform: "translate(1.203 0.162)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressService);
export default __webpack_public_path__ + "static/media/ExpressService.6926ba95f58453eac2f0ae753ab1cd79.svg";
export { ForwardRef as ReactComponent };